import React from 'react';

function About() {
  return (
    <section id="about">
      <div className="container">
        <div className="section-header single">
          <h2>Hakkında</h2>
        </div>
        <div className="about-grid">
          <div className="text-stack">
            <p>
              2010 yılında Boğaziçi Üniversitesi Psikoloji Bölümü'nden mezun olmuştur. Ardından
              İzmir'e yerleşerek Dokuz Eylül Üniversitesi Eğitim Bilimleri Enstitüsü'nde Aile
              Danışmanlığı eğitimini tamamladı ve özel bir danışmanlık merkezinde danışan kabul
              etmeye başladı.
            </p>
            <p>
              Bu süreçte özel bir hastanede görev yaptı ve çeşitli özel eğitim kurumlarında görev
              alarak, özellikle disleksi ve özel öğrenme güçlüğü tanısı almış bireylerin ailelerine
              yönelik destekleyici çalışmalar yürüttü. 2019 yılında Dokuz Eylül Üniversitesi'ndeki
              Psikoloji yüksek lisans eğitimini tamamladı.
            </p>
            <p>
              2019 yılı itibariyle Abdülkadir Özbek Psikodrama Enstitüsü'nde psikodrama ve grup
              psikoterapileri eğitimi almakta ve bu süreçte yardımcı psikodramatist olarak çalışmaya
              devam etmektedir.
            </p>
            <p>
              Psikoterapi alanındaki uzmanlığını geliştirmeye devam ederek, şu anda psikanalitik
              yönelimle yüz yüze ve online çalışma yürütmektedir.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
